export const objectToString = (obj) => {
  try {
    return Object.entries(obj).reduce(
      (text, el) => (text += `-${el?.[0]?.replace(/_/g, ' ')}: <strong>${el?.[1]}</strong> <br/>`),
      ''
    );
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const formatCurrency = (number) => {
  return `$${new Intl.NumberFormat('en', { maximumSignificantDigits: 15 }).format(number)}`;
};

export const boolSiNo = (val) => (val ? 'Sí' : 'No');

export const s = (length = 1, letterPlural = 's', letterSingular = '') =>
  length !== 1 ? letterPlural : letterSingular;

export const eventSlugnameTrim = (eventSlugname = '') => {
  if (Boolean(eventSlugname) && typeof eventSlugname === 'string') {
    return eventSlugname.replace(/_/gi, ' ');
  }
  return eventSlugname;
};

// Hides the trailing "." that marks a paid event in the slug.
export const eventDisplayName = (eventSlugname = '') => {
  const label = eventSlugnameTrim(eventSlugname);
  return typeof label === 'string' ? label.replace(/\./g, '') : label;
};

export const classDictionary = (className) => {
  return className.replace(/class/gi, 'Clase ');
};

export const normalizeSlugname = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .normalize('NFD') // Decompose characters (á → a + ´)
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (accents)
    .replace(/ñ/g, 'n') // Replace ñ with n
    .replace(/Ñ/g, 'N') // Replace Ñ with N
    .replace(/ /g, '_') // Replace spaces with underscores
    .replace(/[^a-zA-Z0-9_.]/g, ''); // Remove all special characters, keep only alphanumeric and underscores
};
